import { API, graphqlOperation } from "aws-amplify";
import { createCustomer, deleteCustomer, updateCustomer } from "../../graphql/mutations";
import { getCustomer, listCustomers } from "../../graphql/queries";

export const CreateCustomer = async (postParams) => {
  try {
    const result = await API.graphql(
      graphqlOperation(createCustomer, postParams)
    );
    return result.data.createCustomer;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const GetCustomer = async () => {
  try {
    const result = await API.graphql(graphqlOperation(listCustomers));
    const data = result.data.listCustomers;
    return data;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const DeleteCustomer = async (params) => {
  try {
    const result = await API.graphql(graphqlOperation(deleteCustomer, params));
    return result;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const GetCustomerById = async (id) => {
  try {
    const result = await API.graphql(graphqlOperation(getCustomer, { customer_id: id }));
    const data = result.data.getCustomer;
    return data;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const UpdateCustomer = async (postParams) => {
  try {
    const result = await API.graphql(graphqlOperation(updateCustomer, postParams));
    return result.data.updateCustomer;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};
